import React from 'react';

import auditLogPropTypes from 'app/audit-logs/auditLogPropTypes';

import AuditLogPanelForRecord from './AuditLogPanelForRecord';
import AuditLogPanelForGlobal from './AuditLogPanelForGlobal';

export default function AuditLogPanel({ recordRef, globalFilters }) {
  return recordRef ? (
    <AuditLogPanelForRecord recordRef={recordRef} />
  ) : (
    <AuditLogPanelForGlobal globalFilters={globalFilters} />
  );
}

AuditLogPanel.propTypes = {
  recordRef: auditLogPropTypes.recordRef,
  globalFilters: auditLogPropTypes.globalFilters,
};
